import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * Helper function to format headers for nike api requests
 *
 * @param {object} params - named parameters for clarity
 * @param {string} params.appId - appId provided by client app (unite uxid)
 * @param {string} params.token - consumer JWT aka user auth token attached to Authorization header (@see ux-tread-unite-redux getAuthToken)
 * @param {string} params.visitId - user visitId attached to x-nike-visitid header (@see ux-tread-unite-redux getVisitId)
 * @param {string} params.visitorId - user visitorId attached to x-nike-visitorid header (@see ux-tread-unite-redux getVisitorId)
 * @param {string} params.appName - client app name to attach to X-B3-SpanName header
 * @param {string} params.spanName - client app name to attach to X-B3-SpanName header
 * @param {string} params.cloudStack - value to attach to cloud_stack header to target certain deployed service stacks
 * @returns {object} Headers for a request
 */
export default function formatHeaders(_ref) {
  var token = _ref.token,
    visitId = _ref.visitId,
    visitorId = _ref.visitorId,
    appId = _ref.appId,
    appName = _ref.appName,
    spanName = _ref.spanName,
    cloudStack = _ref.cloudStack;
  var headers = {
    'Content-Type': 'application/json; charset=UTF-8',
    accept: 'application/json',
    'X-B3-SpanName': appName || spanName,
    appid: appId
  };
  if (cloudStack) {
    headers.cloud_stack = cloudStack;
  }
  if (!token) {
    if (visitorId && visitId) {
      return _objectSpread(_objectSpread({}, headers), {}, {
        'x-nike-visitid': visitId,
        'x-nike-visitorid': visitorId
      });
    }
    return headers;
  }
  return _objectSpread(_objectSpread({}, headers), {}, {
    Authorization: "Bearer ".concat(token)
  });
}